var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('h2',{class:[
    _setup.fontClass,
    'text-body-small',
    'break-words',
    {
      'text-dark-text-200': _vm.colorScheme === 'light',
      'text-light-text-200': _vm.colorScheme === 'dark',
    },
  ],domProps:{"innerHTML":_vm._s(_setup.hyperlinkedText)}})
}
var staticRenderFns = []

export { render, staticRenderFns }